import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Text extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        handleMouseUp: PropTypes.func,
        isWutonghui: PropTypes.bool,
    };

    ref = React.createRef();

    createMarkup = () => {
        const { content } = this.props;

        return { __html: content };
    };

    getImageSize = imageUrl => {
        const matches = imageUrl && imageUrl.match(/w(\d+)_h(\d+)/);

        if (!matches) return null;

        return {
            width: Number(matches[1]),
            height: Number(matches[2]),
        };
    };

    componentDidMount() {
        const { isWutonghui } = this.props;

        if (!isWutonghui) return;

        Array.from(this.ref.current.getElementsByTagName('img')).forEach(image => {
            const imageSize = this.getImageSize(image.getAttribute('src'));

            if (imageSize?.width >= 400) {
                image.classList.add('imgWidthFill');
            }
        });
    }

    render() {
        const { handleMouseUp } = this.props;

        return (
            <div
                className={styles.text}
                dangerouslySetInnerHTML={this.createMarkup()}
                onMouseUp={handleMouseUp}
                ref={this.ref}
            />
        );
    }
}

export default Text;
